import CuentaExpedienteGrid from '../../../../components/controls/CuentaExpedienteGrid';
import CuentaCertificadoEscribanoGrid from '../../../../components/controls/CuentaCertificadoEscribanoGrid';
import RelacionesCuentasGrid from '../../../../components/controls/RelacionesCuentasGrid';
import ControladoresCuentasGrid from '../../../../components/controls/ControladoresCuentasGrid';
import ZonasEntregaGrid from '../../../../components/controls/ZonasEntregaGrid';
import CuentaAplicacionCreditosModal from '../../../../components/controls/CuentaAplicacionCreditosModal';
import CuentaCondonacionModal from '../../../../components/controls/CuentaCondonacionModal';
import CuentaPlanesPagosGrid from '../../../../components/controls/CuentaPlanesPagosGrid';
import ObrasInmuebleGrid from '../../../../components/controls/ObrasInmuebleGrid';
import ValuacionesGrid from '../../../../components/controls/ValuacionesGrid';
import EdesurGrid from '../../../../components/controls/EdesurGrid';
import CatastroForm from '../../../../components/controls/CatastroForm';
import CuentaEmisionEjecucionForm from '../../../../components/controls/CuentaEmisionEjecucionForm';
import { OPERATION_MODE, TRIBUTO_TYPE } from '@laramie/ui';
import CuentaInformeDeuda from '../../../../components/controls/CuentaInformeDeuda';
import Modal from '../../../../components/common/Modal';
import { TIPS } from '../../../../consts/tips';

const MenuLateral = ({ state, listExpedientes, listDireccionesRelacionadas, UpdateEntity, HidePopupMenu, inmueble_formValues }) => {

    const getTitle = () => {
        if (state.menues.obras) return 'Obras';
        if (state.menues.expedientes) return 'Expedientes';
        if (state.menues.certificadosEscribanos) return 'Certificados escribanos';
        if (state.menues.relacionesCuentas) return 'Relaciones con otras cuentas';
        if (state.menues.controladoresCuentas) return 'Controladores de la cuenta';
        if (state.menues.zonasEntrega) return 'Zonas de entrega';
        if (state.menues.valuaciones) return 'Valuaciones';
        if (state.menues.edesur) return 'EDE';
        if (state.menues.catastro) return 'Catastro (ARBA)';
        if (state.menues.aplicacionCreditos) return 'Aplicación de créditos';
        if (state.menues.condonacion) return 'Condonación de deuda';
        if (state.menues.planesPago) return 'Planes de pago';
        if (state.menues.liquidaciones) return 'Liquidaciones';
        if (state.menues.informeDeuda) return 'Informe de deuda';
        return '';
    };

    const getTipName = () => {
        if (state.menues.obras) return TIPS.NAME.MODALS.OBRAS_MODAL;
        if (state.menues.expedientes) return TIPS.NAME.MODALS.EXPEDIENTES_MODAL;
        if (state.menues.certificadosEscribanos) return TIPS.NAME.MODALS.CERTIFICADOS_ESCRIBANOS_MODAL;
        if (state.menues.relacionesCuentas) return TIPS.NAME.MODALS.RELACIONES_CUENTAS_MODAL;
        if (state.menues.controladoresCuentas) return TIPS.NAME.MODALS.CONTROLADORES_CUENTAS_MODAL;
        if (state.menues.zonasEntrega) return TIPS.NAME.MODALS.ZONAS_ENTREGA_MODAL;
        if (state.menues.valuaciones) return TIPS.NAME.MODALS.VALUACIONES_MODAL;
        if (state.menues.edesur) return TIPS.NAME.MODALS.EDESUR_MODAL;
        if (state.menues.catastro) return TIPS.NAME.MODALS.CATASTRO_MODAL;
        if (state.menues.aplicacionCreditos) return TIPS.NAME.MODALS.APLICACION_CREDITOS_MODAL;
        if (state.menues.condonacion) return TIPS.NAME.MODALS.CONDONACION_MODAL;
        if (state.menues.planesPago) return TIPS.NAME.MODALS.PLANES_PAGO_MODAL;
        if (state.menues.liquidaciones) return TIPS.NAME.MODALS.LIQUIDACIONES_MODAL;
        if (state.menues.informeDeuda) return TIPS.NAME.MODALS.INFORME_DEUDA_MODAL;
        return null;
    };

    const tipName = getTipName();

    return (
            <Modal
                size={state.menues.informeDeuda ? "lg" : "xl"}
                allowFullscreen={state.menues.liquidaciones}
                title={getTitle()}
                tipName={tipName}
                onEscape={HidePopupMenu}
                body={(
                        <>
                            {state.menues.obras && (
                                <ObrasInmuebleGrid
                                    processKey={state.processKey}
                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                    data={{
                                        idInmueble: state.id,
                                        list: state.entity.obrasInmueble
                                    }}
                                    onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                />
                            )}
                            {state.menues.expedientes && (
                                <CuentaExpedienteGrid
                                    data={{
                                        listIdExpedientes: listExpedientes
                                    }}
                                />
                            )}
                            {state.menues.certificadosEscribanos && (
                                <CuentaCertificadoEscribanoGrid
                                    data={{
                                        idCuenta: state.entity.cuenta.id
                                    }}
                                />
                            )}
                            {state.menues.relacionesCuentas && (
                                <RelacionesCuentasGrid
                                    processKey={state.processKey}
                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                    data={{
                                        idCuenta: state.entity.cuenta.id,
                                        list: state.entity.relacionesCuentas
                                    }}
                                    onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                />
                            )}
                            {state.menues.controladoresCuentas && (
                                <ControladoresCuentasGrid
                                    processKey={state.processKey}
                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                    data={{
                                        idCuenta: state.entity.cuenta.id,
                                        list: state.entity.controladoresCuentas,
                                        idTipoTributo: state.entity.cuenta.idTipoTributo
                                    }}
                                    onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                />
                            )}
                            {state.menues.zonasEntrega && (
                                <ZonasEntregaGrid
                                    processKey={state.processKey}
                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                    data={{
                                        idCuenta: state.entity.cuenta.id,
                                        list: state.entity.zonasEntrega,
                                        listDireccionesRelacionadas: listDireccionesRelacionadas,
                                    }}
                                    onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                />
                            )}
                            {state.menues.valuaciones && (
                                <ValuacionesGrid
                                    processKey={state.processKey}
                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                    data={{
                                        idInmueble: state.id,
                                        list: state.entity.valuaciones
                                    }}
                                    onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                />
                            )}
                            {state.menues.edesur && (
                                <EdesurGrid
                                    processKey={state.processKey}
                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                    data={{
                                        idInmueble: state.id,
                                        list: state.entity.edesur
                                    }}
                                    onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                />
                            )}
                            {state.menues.catastro && (
                                <CatastroForm
                                    disabled={true}
                                    data={{
                                        partida: inmueble_formValues.catastralRtasPrv,
                                        circunscripcion: inmueble_formValues.catastralCir,
                                        seccion: inmueble_formValues.catastralSec,
                                        chacra: inmueble_formValues.catastralChacra,
                                        letraChacra: inmueble_formValues.catastralLchacra,
                                        quinta: inmueble_formValues.catastralQuinta,
                                        letraQuinta: inmueble_formValues.catastralLquinta,
                                        fraccion: inmueble_formValues.catastralFrac,
                                        letraFraccion: inmueble_formValues.catastralLfrac,
                                        manzana: inmueble_formValues.catastralManz,
                                        letraManzana: inmueble_formValues.catastralLmanz,
                                        parcela: inmueble_formValues.catastralParc,
                                        letraParcela: inmueble_formValues.catastralLparc,
                                        subparcela: inmueble_formValues.catastralSubparc,
                                        catastralCodigo: inmueble_formValues.catastralCodigo,
                                        partido: inmueble_formValues.catastralPartido
                                    }}
                                />
                            )}
                            {state.menues.aplicacionCreditos && (
                                <CuentaAplicacionCreditosModal
                                    idCuenta={state.entity.cuenta.id}
                                    idTipoTributo={TRIBUTO_TYPE.INMUEBLES}
                                    onClickVolver={HidePopupMenu}
                                />
                            )}
                            {state.menues.condonacion && (
                                <CuentaCondonacionModal
                                    idCuenta={state.entity.cuenta.id}
                                    idTipoTributo={state.entity.cuenta.idTipoTributo}
                                    onClickVolver={HidePopupMenu}
                                />
                            )}
                            {state.menues.planesPago && (
                                <CuentaPlanesPagosGrid
                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                    data={{
                                        idCuenta: state.entity.cuenta.id
                                    }}
                                />
                            )}
                            {state.menues.liquidaciones && (
                                <CuentaEmisionEjecucionForm
                                    data={{
                                        idCuenta: state.entity.cuenta.id,
                                        idTipoTributo: state.entity.cuenta.idTipoTributo
                                    }}
                                    onDismiss={() => HidePopupMenu()}
                                />
                            )}
                            {state.menues.informeDeuda && (
                                <CuentaInformeDeuda
                                    data={{
                                        idCuenta: state.entity.cuenta.id,
                                        idTipoTributo: 10
                                    }}
                                    onDismiss={HidePopupMenu}
                                />
                            )}
                        </>
                )}
                footerClassName={!(state.menues.aplicacionCreditos || state.menues.condonacion || state.menues.informeDeuda) ? "f-align" : "d-none"}
                footer={!(state.menues.aplicacionCreditos || state.menues.condonacion || state.menues.informeDeuda) && (
                        <button className="btn back-button" data-dismiss="modal" onClick={(event) => HidePopupMenu()}>Volver</button>
                )}
            />
    )
}
export default MenuLateral
